const _temp0 = require("./activity-2-part-1-blankets.vue");
const _temp1 = require("./activity-2-part-1-book.vue");
const _temp2 = require("./activity-2-part-1-coffee.vue");
const _temp3 = require("./activity-2-part-1-food.vue");
const _temp4 = require("./activity-2-part-1-gas.vue");
const _temp5 = require("./activity-2-part-1-tools.vue");
module.exports = {
  "blankets": _temp0,
  "book": _temp1,
  "coffee": _temp2,
  "food": _temp3,
  "gas": _temp4,
  "tools": _temp5
}